/*
  Cart -> Mini PDP. Clicking a watch's image or title in the cart opens the
  EXISTING Mini PDP overlay (assets/aurelior-product-overlay.js,
  AurelioProductOverlay) instead of the full product page. No second overlay,
  no extra fetching: it reuses the product card's own <template>.

  - On a collection page every product card records its product id ->
    collection path in sessionStorage (this tab only, nothing sent to Shopify).
  - Click on the page that already shows the card: close the drawer, open it.
  - Otherwise, for eligible watches, go to the remembered collection (or the
    Final Collection) with ?minipdp=<product id>&mpv=<variant id>; on load the
    overlay opens once the page's scripts have run (DOMContentLoaded), then
    the parameters are removed from the address.
  Anything without a card/overlay falls back to the normal product link.
*/
(function () {
  var KEY = 'aurelior_minipdp_origin';
  var FALLBACK = 'collections/final-collection-70-off';

  function readMap() {
    try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  }
  function writeMap(map) {
    try { sessionStorage.setItem(KEY, JSON.stringify(map)); } catch (e) {}
  }
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function overlayReady() {
    return typeof AurelioProductOverlay !== 'undefined';
  }
  function findCard(productId) {
    var cards = document.querySelectorAll('aurelior-product-card[data-product-id="' + productId + '"]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].querySelector('template[data-product-overlay-template]')) return cards[i];
    }
    return null;
  }
  function openFor(productId, variantId, triggerEl) {
    var card = findCard(productId);
    if (!card || !overlayReady()) return false;
    var title = card.querySelector('.aurelior-pc__title');
    AurelioProductOverlay.open({
      template: card.querySelector('template[data-product-overlay-template]'),
      variantId: variantId || card.dataset.defaultVariantId,
      title: title ? title.textContent.trim() : '',
      triggerEl: triggerEl || null
    });
    return true;
  }

  // Remember where each product was seen (collection pages only).
  function recordOrigin() {
    if (!/\/collections\/[^/]+\/?$/.test(location.pathname)) return;
    var cards = document.querySelectorAll('aurelior-product-card[data-product-id]');
    if (!cards.length) return;
    var map = readMap();
    cards.forEach(function (c) { map[c.dataset.productId] = location.pathname; });
    writeMap(map);
  }

  function openFromUrl() {
    var params = new URLSearchParams(location.search);
    var pid = params.get('minipdp');
    if (!pid) return;
    var vid = params.get('mpv');
    openFor(pid, vid, null);
    params.delete('minipdp');
    params.delete('mpv');
    var qs = params.toString();
    history.replaceState(history.state, '', location.pathname + (qs ? '?' + qs : '') + location.hash);
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target;
    var link = target.closest && target.closest('a[data-cart-minipdp]');
    if (!link && target.closest) {
      // The image sits next to its (overlay) link in the same cell.
      var img = target.closest('.cart-item__image');
      if (img) link = img.parentElement.querySelector('a[data-cart-minipdp]');
    }
    if (!link) return;

    var pid = link.dataset.productId;
    var vid = link.dataset.variantId;
    var drawer = document.querySelector('cart-drawer');

    if (findCard(pid) && overlayReady()) {
      event.preventDefault();
      if (drawer && typeof drawer.close === 'function') drawer.close();
      openFor(pid, vid, link);
      return;
    }

    if (!link.hasAttribute('data-watch')) return; // not a Mini PDP product: normal link
    var map = readMap();
    var path = map[pid] || (root() + FALLBACK);
    event.preventDefault();
    location.href = path + '?minipdp=' + encodeURIComponent(pid) + '&mpv=' + encodeURIComponent(vid);
  });

  function init() {
    recordOrigin();
    openFromUrl();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
